import type { ComponentProps, PropsWithChildren } from "react";
import { Button as AriaButton } from "react-aria-components";
import { tw } from "src/design-system/tw";

export function PromoPreviewContainer({
  onPress,
  children,
}: PropsWithChildren<{
  onPress?: ComponentProps<typeof AriaButton>["onPress"];
}>) {
  return (
    <AriaButton
      className={tw(
        "group relative flex min-w-39.5 grow cursor-pointer snap-center flex-col gap-3 rounded-lg text-left",
        "md:min-w-auto md:snap-none",
        "data-focus-visible:outline-2 data-focus-visible:outline-offset-2 data-focus-visible:outline-ring",
      )}
      onPress={onPress}
    >
      {children}
    </AriaButton>
  );
}
